import React, { Component } from 'react';
import ReactTooltip from 'react-tooltip';

import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import './ag-theme-ela.css';

const DEFAULT_MIN_WIDTH_CELL = 10;
const DEFAULT_MAX_WIDTH_CELL = 800;

const defaultColDef = {
  resizable: true,
  sortable: true,
  filter: true,
  minWidth: DEFAULT_MIN_WIDTH_CELL,
  maxWidth: DEFAULT_MAX_WIDTH_CELL,
  cellStyle: {
    borderRight: '1px solid #ccc',
  },
};

const columns = [
  { headerName: 'Job #', field: 'jobNum', width: 70 },
  { headerName: 'Date', field: 'jobDateTime', width: 90 },
  {
    headerName: 'Claimant',
    field: 'clmLastName',
    valueFormatter: (params) =>
      params.data.clmLastName && params.data.clmFirstName
        ? `${params.data.clmLastName}, ${params.data.clmFirstName}`
        : params.data.clmLastName || '',
    width: 130,
  },
  { headerName: 'CLM #', field: 'clmClaimNumber', width: 100 },
  {
    headerName: 'Interpreter',
    field: 'intLastName',
    valueFormatter: (params) =>
      params.data.intLastName && params.data.intFirstName
        ? `${params.data.intLastName}, ${params.data.intFirstName}`
        : params.data.intLastName || '',
    width: 130,
  },
  { headerName: 'Provider', field: 'providerName', width: 120 },
  {
    headerName: 'Rep',
    field: 'repLastName',
    valueFormatter: (params) =>
      params.data.repLastName && params.data.repFirstName
        ? `${params.data.repLastName}, ${params.data.repFirstName}`
        : params.data.repLastName || '',
    width: 120,
  },
  { headerName: 'Client', field: 'clientAbbrv', width: 100 },
];

export class WorkOrderFormSearchTableDefault extends Component {
  static displayName = WorkOrderFormSearchTableDefault.name;

  constructor(props) {
    super(props);
    this.state = {
      columnWidths: columns.reduce((acc, col) => {
        acc[col.field] = col.width || DEFAULT_MIN_WIDTH_CELL;
        return acc;
      }, {}),
    };
    this.onColumnResized = this.onColumnResized.bind(this);
    this.autoSizeUnspecifiedColumns =
      this.autoSizeUnspecifiedColumns.bind(this);
    this.adjustHeaderHeight = this.adjustHeaderHeight.bind(this);
    this.onGridReady = this.onGridReady.bind(this);
  }

  componentDidMount() {
    ReactTooltip.rebuild();
  }

  autoSizeUnspecifiedColumns = () => {
    const allColumnIds = [];
    this.gridColumnApi.getColumns().forEach((column) => {
      if (column.getColDef().width === undefined) {
        allColumnIds.push(column.colId);
      }
    });
    if (allColumnIds.length > 0) {
      this.gridColumnApi.autoSizeColumns(allColumnIds, false);
    }
  };

  adjustHeaderHeight = (gridApi) => {
    window.requestAnimationFrame(() => {
      const allColumnHeaders = document.querySelectorAll(
        '.ag-header-cell-text'
      );
      let maxHeight = 0;
      allColumnHeaders.forEach((header) => {
        if (header.parentElement.clientHeight > maxHeight) {
          maxHeight = header.parentElement.clientHeight;
        }
      });
      maxHeight += 10;
      gridApi.setHeaderHeight(maxHeight);
    });
  };

  onGridReady = (params) => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.setState({ gridApiReady: true });
    this.adjustHeaderHeight(params.api);
    this.autoSizeUnspecifiedColumns(false);
  };

  onColumnResized = (params) => {
    if (params.finished) {
      const newWidths = { ...this.state.columnWidths };
      params.columns.forEach((column) => {
        newWidths[column.getColId()] = column.getActualWidth();
      });
      this.setState({ columnWidths: newWidths }, () => {
        this.adjustHeaderHeight(this.gridApi);
      });
    }
  };

  render() {
    const gridOptions = {
      suppressSizeToFit: true,
      columnDefs: columns,
      rowData: this.props.workOrderList,
      animateRows: true,
      defaultColDef: defaultColDef,
      components: {},
      onColumnResized: this.onColumnResized,
      rowHeight: 20,
      tooltipShowDelay: 0,
      enableBrowserTooltips: true,
      onRowDoubleClicked: this.props.handleDoubleClick,
    };

    return (
      <div
        className="ag-theme-balham"
        style={{
          width: '100%',
          height: '300px',
        }}
      >
        <AgGridReact
          {...gridOptions}
          onGridReady={this.onGridReady}
          rowSelection={'single'}
        />
      </div>
    );
  }
}
